import { APP_ROUTER } from '@/routes/routes';
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

interface IProps {
  title?: string;
}

export const NotFound: React.FC<IProps> = ({ title }) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Result
        status='404'
        title='404'
        subTitle='The resource you are looking for could not be found. Please check the URL and try again.'
        extra={
          <Link to={APP_ROUTER.HOME}>
            <Button type='primary'>Back Home</Button>
          </Link>
        }
      />
    </>
  );
};
